import LanguageCmsEditor from '@/pages/admin/content/components/LanguageCmsEditor';

export default function AdminDariCmsPage() {
  return <LanguageCmsEditor language="da" />;
}